import React from 'react';
import classNames from 'classnames';
import { BackgroundColorEnum, FillColorEnum } from '@/enums/styling';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';

function Wave({ backgroundColor = 'WHITE', fillColor = 'WHITE' }) {
	const fillColorClass = getTailwindClassByEnum(FillColorEnum, fillColor);
	const backgroundColorClass = getTailwindClassByEnum(BackgroundColorEnum, backgroundColor);

	return (
		<>
			<svg
				className={classNames(fillColorClass, backgroundColorClass, 'xl:hidden')}
				viewBox="0 0 1280 40"
				preserveAspectRatio="none"
			>
				<g id="Page-1">
					<g id="Artboard-Copy-3" transform="translate(0.000000, -738.000000)">
						<path
							d="M1280,778.810694 L0,778.810694 L0,762.506346 C75.5555556,746.709244 182.222222,738.810694 320,738.810694 C385.647059,738.810694 452.303114,742.84668 519.647661,748.354614 L528.069292,749.050587 L536.497956,749.760779 L544.933514,750.484079 L553.375825,751.219373 L561.824753,751.965548 L570.280156,752.721492 L578.741897,753.486091 L587.209835,754.258233 L604.16375,755.820694 L616.98877,757.012854 L653.454212,760.414794 L666.506801,761.624901 L675.214769,762.426725 L683.927557,763.223235 L692.645017,764.013244 L701.367001,764.795564 L712.275616,765.760847 L712.275616,765.760847 L723.190778,766.709946 L731.927427,767.456016 L740.344142,768.162155 C813.304121,774.22662 886.652061,778.810694 960,778.810694 C965.777778,778.810694 971.495111,778.800027 977.152,778.778694 L985.592,778.738694 C1117.10844,777.986694 1215.24444,771.344027 1280,758.810694 L1280,778.810694 Z"
							id="Wave"
						/>
					</g>
				</g>
			</svg>
			<svg
				className={classNames(fillColorClass, backgroundColorClass, 'hidden xl:block')}
				viewBox="0 0 3840 96"
				preserveAspectRatio="none"
			>
				<g id="Page-1">
					<g id="Artboard-Copy-3" transform="translate(0.000000, -2328.000000)">
						<g id="style-element/wave/wave-D" transform="translate(0.000000, 2328.000000)">
							<path
								d="M3840,96 L0,96 L0,56.8695652 C226.666667,18.9565217 546.666667,0 960,0 C1156.94118,0 1356.90934,9.68636678 1558.94298,22.9054085 L1584.20788,24.5757429 L1609.49387,26.2802052 L1634.80054,28.0161244 L1660.12748,29.7808296 L1685.47426,31.5716501 L1710.84047,33.3859149 L1736.22569,35.2209532 L1761.62951,37.074094 L1812.49125,40.824 L1850.96631,43.685184 L1960.36264,51.8498416 L1999.5204,54.7540967 L2025.64431,56.6784755 L2051.78267,58.5900992 L2077.93505,60.4861199 L2104.101,62.36369 L2136.82685,64.6803682 L2136.82685,64.6803682 L2169.57233,66.958206 L2195.78228,68.7487736 L2221.03243,70.4435074 C2439.91236,84.9982223 2659.95618,96 2880,96 C2897.33333,96 2914.48533,95.9744 2931.456,95.9232 L2956.776,95.8272 C3351.32533,94.0224 3645.73333,78.08 3840,48 L3840,96 Z"
								id="Wave"
							/>
						</g>
					</g>
				</g>
			</svg>
		</>
	);
}

export default Wave;
